import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../HomePage/OurCategories.css";
import { Link } from "react-router-dom";
import { API_URL } from "../../_services/apiUrl";
import { get } from "../../_services/apiService";
import { Rating } from 'react-simple-star-rating';
import { useWishlist } from "../../context/wishlistContext";

const DEFAULT_CLIENT_IMAGE = "/images/gray-user-profile-icon.png";

const ClientsReviews = () => {
    const { guestIdInt } = useWishlist();
    const [reviews, setReviews] = useState([]);
    const [failedClientImages, setFailedClientImages] = useState({});

    useEffect(() => {
        if (!guestIdInt) return;

        const fetchReviewsList = async () => {
            try {

                const response = await get(API_URL.ReviewsList, {

                    guest_id: guestIdInt,
                });
                setReviews(response?.data || []);
            } catch (error) {
                setReviews([]);
            }
        };

        fetchReviewsList();
    }, [guestIdInt]);





























    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 2000,
                    arrows: false,
                },
            },
        ],
    };

    const getAverageRating = (reviews) => {
        if (!Array.isArray(reviews) || reviews.length === 0) return 0;

        const total = reviews.reduce((sum, review) => sum + Number(review?.rating || 0), 0);
        const avg = total / reviews.length;

        return parseFloat(avg.toFixed(1));
    };

    const averageRating = getAverageRating(reviews);

    const getClientImageKey = (item, index) => {
        return item?.id || item?.customer_id || item?.customer?.id || index;
    };

    const getClientImage = (item, index) => {
        const imageKey = getClientImageKey(item, index);

        if (failedClientImages[imageKey]) {
            return DEFAULT_CLIENT_IMAGE;
        }

        return item?.customer?.image || DEFAULT_CLIENT_IMAGE;
    };

    const handleClientImageError = (item, index) => {
        const imageKey = getClientImageKey(item, index);

        setFailedClientImages((prevState) => ({
            ...prevState,
            [imageKey]: true,
        }));
    };

    return (
        <div>
            <section className="same_space_div clients_wepper">
                <div className="container">
                    <div className="review_wepper section_heading">
                        <h2>Clients Reviews</h2>
                        <div className='avg_rating_home d-flex align-items-center justify-content-center gap-1 mb-3'>
                            <Rating
                                initialValue={averageRating}
                                readonly
                                size={22}
                                label={`Rating: ${averageRating || 0}`}
                                fractions={2}
                                fillColor="gold"
                                emptyColor="#ccc"
                                className='p-0'
                            />
                            <span className='avg_rate_total'>{`(${averageRating})`}</span>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="210" height="18" viewBox="0 0 210 18" fill="none">
                            <path d="M85.4253 10.4814L0.952113 9.15095C0.902132 9.15964 0.850903 9.15792 0.80162 9.14589C0.752337 9.13386 0.706065 9.11176 0.665712 9.08102C0.62536 9.05027 0.591793 9.01153 0.567112 8.96721C0.542431 8.92289 0.527165 8.87394 0.522278 8.82345C0.527191 8.73276 0.565433 8.64708 0.629655 8.58286C0.693876 8.51864 0.779547 8.4804 0.870237 8.47549L85.3435 7.14502C85.7593 7.19087 86.1435 7.38855 86.4227 7.70014C86.7018 8.01174 86.8561 8.41536 86.8561 8.83369C86.8561 9.25202 86.7018 9.65564 86.4227 9.96724C86.1435 10.2788 85.7593 10.4765 85.3435 10.5223L85.4253 10.4814Z" fill="url(#paint0_linear_167_36)" />
                            <path d="M106.999 14.1453L105.096 17.6863L103.11 14.1862L99.3645 15.6599L100.101 11.7095L96.2738 10.4405L99.385 7.8819L97.2563 4.44322L101.289 4.48417L101.882 0.492799L104.952 3.11279L107.961 0.431396L108.616 4.42277L112.649 4.29993L110.602 7.7591L113.754 10.2767L109.967 11.6072L110.786 15.5576L106.999 14.1453Z" fill="url(#paint1_linear_167_36)" />
                            <path d="M91.8936 11.6483C93.4763 11.6483 94.7592 10.3653 94.7592 8.78268C94.7592 7.20007 93.4763 5.91711 91.8936 5.91711C90.311 5.91711 89.0281 7.20007 89.0281 8.78268C89.0281 10.3653 90.311 11.6483 91.8936 11.6483Z" fill="url(#paint2_linear_167_36)" />
                            <path d="M124.519 7.1046L208.972 8.43503C209.02 8.43495 209.067 8.44458 209.11 8.46333C209.154 8.48208 209.193 8.50959 209.226 8.5441C209.258 8.57861 209.283 8.61942 209.3 8.66403C209.316 8.70864 209.323 8.75609 209.32 8.80348C209.315 8.89417 209.277 8.97984 209.213 9.04406C209.148 9.10829 209.063 9.14653 208.972 9.15144L124.519 10.4819C124.282 10.508 124.042 10.4839 123.814 10.4109C123.587 10.338 123.377 10.218 123.2 10.0586C123.022 9.89931 122.879 9.70426 122.782 9.48622C122.685 9.26818 122.634 9.03205 122.634 8.79324C122.634 8.55443 122.685 8.31829 122.782 8.10025C122.879 7.88222 123.022 7.68717 123.2 7.52783C123.377 7.36849 123.587 7.24842 123.814 7.1755C124.042 7.10257 124.282 7.07843 124.519 7.1046Z" fill="url(#paint3_linear_167_36)" />
                            <path d="M118.032 11.6483C119.614 11.6483 120.897 10.3653 120.897 8.78268C120.897 7.20007 119.614 5.91711 118.032 5.91711C116.449 5.91711 115.166 7.20007 115.166 8.78268C115.166 10.3653 116.449 11.6483 118.032 11.6483Z" fill="url(#paint4_linear_167_36)" />
                            <defs>
                                <linearGradient id="paint0_linear_167_36" x1="43.8744" y1="-9.78247" x2="43.8744" y2="15.2096" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#B27F2A" />
                                    <stop offset="0.06" stopColor="#B7862E" />
                                    <stop offset="0.14" stopColor="#C49939" />
                                    <stop offset="0.24" stopColor="#DAB84C" />
                                    <stop offset="0.33" stopColor="#F4DD62" />
                                    <stop offset="0.52" stopColor="#F4E38B" />
                                    <stop offset="0.66" stopColor="#F4DD62" />
                                    <stop offset="1" stopColor="#B27F2A" />
                                </linearGradient>
                                <linearGradient id="paint1_linear_167_36" x1="105.014" y1="-9.78236" x2="105.014" y2="15.2096" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#B27F2A" />
                                    <stop offset="0.06" stopColor="#B7862E" />
                                    <stop offset="0.14" stopColor="#C49939" />
                                    <stop offset="0.24" stopColor="#DAB84C" />
                                    <stop offset="0.33" stopColor="#F4DD62" />
                                    <stop offset="0.52" stopColor="#F4E38B" />
                                    <stop offset="0.66" stopColor="#F4DD62" />
                                    <stop offset="1" stopColor="#B27F2A" />
                                </linearGradient>
                                <linearGradient id="paint2_linear_167_36" x1="91.8936" y1="-9.78219" x2="91.8936" y2="15.2098" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#B27F2A" />
                                    <stop offset="0.06" stopColor="#B7862E" />
                                    <stop offset="0.14" stopColor="#C49939" />
                                    <stop offset="0.24" stopColor="#DAB84C" />
                                    <stop offset="0.33" stopColor="#F4DD62" />
                                    <stop offset="0.52" stopColor="#F4E38B" />
                                    <stop offset="0.66" stopColor="#F4DD62" />
                                    <stop offset="1" stopColor="#B27F2A" />
                                </linearGradient>
                                <linearGradient id="paint3_linear_167_36" x1="166.05" y1="-9.78181" x2="166.05" y2="15.2101" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#B27F2A" />
                                    <stop offset="0.06" stopColor="#B7862E" />
                                    <stop offset="0.14" stopColor="#C49939" />
                                    <stop offset="0.24" stopColor="#DAB84C" />
                                    <stop offset="0.33" stopColor="#F4DD62" />
                                    <stop offset="0.52" stopColor="#F4E38B" />
                                    <stop offset="0.66" stopColor="#F4DD62" />
                                    <stop offset="1" stopColor="#B27F2A" />
                                </linearGradient>
                                <linearGradient id="paint4_linear_167_36" x1="118.032" y1="-9.78219" x2="118.032" y2="15.2098" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#B27F2A" />
                                    <stop offset="0.06" stopColor="#B7862E" />
                                    <stop offset="0.14" stopColor="#C49939" />
                                    <stop offset="0.24" stopColor="#DAB84C" />
                                    <stop offset="0.33" stopColor="#F4DD62" />
                                    <stop offset="0.52" stopColor="#F4E38B" />
                                    <stop offset="0.66" stopColor="#F4DD62" />
                                    <stop offset="1" stopColor="#B27F2A" />
                                </linearGradient>
                            </defs>
                        </svg>
                        {reviews?.length > 1 ? (
                            <Slider {...settings}>
                                {reviews.map((item, index) => (
                                    <div key={index} className="slider-item client_reciew_image">
                                        <img
                                            src={getClientImage(item, index)}
                                            alt={item?.customer?.name || "User"}
                                            className="slider-image"
                                            onError={() => handleClientImageError(item, index)}
                                        />

                                        <div className="rating-wrapper">
                                            <Rating
                                                initialValue={item?.rating || 0}
                                                readonly
                                                size={22}
                                                label={`Rating: ${item?.rating || 0}`}
                                                fractions={2}
                                                fillColor="gold"
                                                emptyColor="#ccc"
                                            />
                                        </div>

                                        <h4 className="userName_review">
                                            {item?.customer?.name || ""}
                                        </h4>

                                        <p>{item?.comment || "No review comment"}</p>
                                    </div>
                                ))}
                            </Slider>
                        ) : (
                            reviews?.map((item, index) => (
                                <div key={index} className="slider-item client_reciew_image">
                                    <img
                                        src={getClientImage(item, index)}
                                        alt={item?.customer?.name || "User"}
                                        className="slider-image"
                                        onError={() => handleClientImageError(item, index)}
                                    />

                                    <div className="rating-wrapper">
                                        <Rating
                                            initialValue={item?.rating || 0}
                                            readonly
                                            size={22}
                                            label={`Rating: ${item?.rating || 0}`}
                                            fractions={2}
                                            fillColor="gold"
                                            emptyColor="#ccc"
                                        />
                                    </div>

                                    <h4 className="userName_review">
                                        {item?.customer?.name || ""}
                                    </h4>

                                    <p>{item?.comment || "No review comment"}</p>
                                </div>
                            ))
                        )}
                    </div>

                    <div
                        className="row mt-5 pt-5 margin_zero"
                        data-aos="fade-down"
                        data-aos-duration="3000"
                    >
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="jewellery_wepper">
                                <img src="images/handpic111.png" alt="" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-4 col-sm-6 col-12">
                            <div className="jewellery_wepper only_top">
                                <img src="images/rose.png" alt="" />
                                <h2>
                                    Handpicked Jewelry Curated for You, from all Across India
                                </h2>
                                <p>
                                    Choose from an extensive range of high-quality materials,
                                    printing techniques & latest designs library.
                                </p>
                                <div className="view_btn mt-4">
                                    <Link to='/products'>Shop Now</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="jewellery_wepper only_top">
                                <img src="images/handpic222.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ClientsReviews;
